import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row, Label } from "reactstrap";
import Select from "react-select";
import "../sass/blogs.scss";
import TextSlicer from "../../components/TextSlicer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories, getAllPosts } from "../../slices/thunks";
import Loader from "../../components/Loader";
import MetaData from "../../components/MetaData";

const description = `At SoftoRithm Technologies we believe in honest and correct information is the right of every individual. We are living in a digital era where the free flow of information is a constant factor in everyday life. Businesses use a wide array of different channels to deliver their message to their customers. Most used channels frequent between blogs, infographics, social media posts, videos, and much more. It's the choice of business to pick one medium that fits how they operate, on how they educate their customers about their products and services. Content is the key to deliver the information and to stay relevant to your targeted audience.`;

const des2 = `Keeping the need of proper and understandable information in mind, SoftoRithm Technologies has created this blog section. The purpose of this section is to provide all the latest news, trends, updates related to the marketing, designing, and development industry. This will act as a one-stop place for our clients and for the people who want all the latest happenings in the above-mentioned industries across. To get all the news, updates, tips, or tricks to improve your design, development, and marketing, you now know the place. Yes, you are right!`;

const Blogs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { posts, isPostSuccess, categories, isCategorySuccess } = useSelector(
    (state) => ({
      posts: state.Posts.posts,
      isPostSuccess: state.Posts.isPostSuccess,
      categories: state.Posts.categories,
      isCategorySuccess: state.Posts.isCategorySuccess,
    }),
  );

  const [blogList, setBlogList] = useState(posts);
  const [categoryList, setCategoryList] = useState(categories);

  useEffect(() => {
    if (posts && !posts.length) {
      dispatch(getAllPosts());
    }
  }, []);

  useEffect(() => {
    setBlogList(posts);
  }, [posts]);

  useEffect(() => {
    if (categories && !categories.length) {
      dispatch(getAllCategories());
    }
  }, []);

  useEffect(() => {
    setCategoryList(categories);
  }, [categories]);

  const transformedCategories = categories?.map((category) => ({
    label: category.categoryName,
    value: category.categoryId,
  }));

  const category = (e) => {
    if (e !== "") {
      setBlogList(posts.filter((item) => item.category === e));
    } else {
      setBlogList(posts);
    }
  };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleCategoryChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    category(selectedOption.label);
  };

  const searchCategory = () => {
    var searchProductList = document.getElementById("searchProductList");
    var inputVal = searchProductList.value.toLowerCase();

    function filterItems(arr, query) {
      return arr.filter(function (el) {
        return el.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    }

    var filterData;

    if (inputVal.trim() === "") {
      // If the search input is empty, show all records
      setSelectedOption("");
      category(selectedOption.value);
      filterData = [...posts];
      // Create a shallow copy of the original array
    } else {
      // Otherwise, filter based on the search query
      filterData = filterItems([...blogList], inputVal); // Create a copy and filter
    }

    if (filterData.length === 0) {
      document.getElementById("noresult").style.display = "block";
      // document.getElementById("loadmore").style.display = "none";
    } else {
      document.getElementById("noresult").style.display = "none";
      // document.getElementById("loadmore").style.display = "block";
    }

    setBlogList(filterData);
  };

  const handleClick = (item) => {
    const url = `/blogs/${item.slug}`;
    window.open(url, "_blank"); // Opens in a new tab
  };

  return (
    <>
      <MetaData metaTitle={"Blogs"} metaDescription={description} />
      {/* <AnimatePage> */}
      <div className="blog">
        <div className="page_body">
          <div className="container mt-5">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="about_rgt_cont">
                  <h1 className="text-center mb-4">Explore Blogs</h1>
                  <h2 className="mb-4">Dose of Information You Need To Know!</h2>

                  <Row className="">
                    <Col lg={6}>
                      <TextSlicer text={description} />
                    </Col>
                    <Col lg={6}>
                      <TextSlicer text={des2} />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <Row>
              <Col lg={12} className="mb-4">
                <Card>
                  <CardHeader className="border-0">
                    <div className="d-flex align-items-center"></div>

                    <Row className="">
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Search
                          </Label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search blog"
                            autoComplete="off"
                            id="searchProductList"
                            onKeyUp={searchCategory}
                          />
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="product-title-input"
                          >
                            Select Category
                          </Label>
                          <Select
                            value={selectedOption}
                            onChange={handleCategoryChange}
                            options={transformedCategories}
                            id="select-category"
                            placeholder="Select Category"
                            isSearchable={false}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            </Row>

            {isPostSuccess ? (
              <>
                <Row
                  className="row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-1"
                  id="explorecard-list"
                >
                  {blogList &&
                    blogList?.map(
                      (item, key) =>
                        item.status === "Approved" && (
                          <Col className="list-element" key={key}>
                            <div
                              onClick={() => {
                                if (item?.status !== "Pending") {
                                  handleClick(item);
                                }
                              }}
                              style={{
                                cursor: `${
                                  item?.status === "Pending" ? "" : "pointer"
                                }`,
                              }}
                            >
                              <Card
                                className="explore-box card-animate"
                                style={{
                                  filter: `${
                                    item?.status === "Pending"
                                      ? "blur(5px)"
                                      : ""
                                  }`,
                                }}
                              >
                                <div className="explore-place-bid-img">
                                  <input
                                    type="hidden"
                                    className="form-control"
                                    id="1"
                                  />
                                  <div className="d-none">undefined</div>
                                  <img
                                    src={item.imgOne}
                                    alt=""
                                    className="card-img-top explore-img"
                                  />
                                  <div className="bg-overlay"></div>
                                </div>

                                <CardBody>
                                  <p className="mb-1">{item.title}</p>
                                  <p className="text-muted mb-0">
                                    {item?.category?.categoryTitle}
                                  </p>
                                </CardBody>
                              </Card>
                            </div>
                          </Col>
                        ),
                    )}
                </Row>
              </>
            ) : (
              <Loader />
            )}

            <div
              className="py-4 text-center"
              id="noresult"
              style={{ display: "none" }}
            >
              <lord-icon
                src="https://cdn.lordicon.com/msoeawqm.json"
                trigger="loop"
                colors="primary:#405189,secondary:#0ab39c"
                style={{ width: "72px", height: "72px" }}
              ></lord-icon>
              <h5 className="mt-4">Sorry! No Result Found</h5>
            </div>
            <div className="text-center mb-3">
              <button className="btn btn-link text-success mt-2" id="loadmore">
                {/* <i className="mdi mdi-loading mdi-spin fs-20 align-middle me-2"></i>
                Load More */}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </AnimatePage> */}
    </>
  );
};

export default Blogs;
